import { render, staticRenderFns } from "./UploadApk.vue?vue&type=template&id=64c4e65a&scoped=true&"
import script from "./UploadApk.vue?vue&type=script&lang=js&"
export * from "./UploadApk.vue?vue&type=script&lang=js&"
import style0 from "./UploadApk.vue?vue&type=style&index=0&id=64c4e65a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4e65a",
  null
  
)

export default component.exports